import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { ModalTypeEnum } from '../../../../app/enums/ModalTypeEnum';
import { useStore } from '../../../../app/store';
import Modal from '../../Modal';
import TodoForm from '../../Todo/TodoForm';

export function TodoModal() {
  const { openModal, todo, todoLeadId, todoEventId, handleCloseModal } =
    useStore(
      useShallow((state) => ({
        openModal: state.modal.openModal,
        todo: state.modal.todo,
        todoLeadId: state.modal.todoLeadId,
        todoEventId: state.modal.todoEventId,
        handleCloseModal: state.modal.handleCloseModal,
      })),
    );
  const { t } = useTranslation();

  if (openModal !== ModalTypeEnum.Todo) return null;

  return (
    <Modal
      className="w-full max-w-[500px]"
      title={t(todo ? 'todo.modal.titleEdit' : 'todo.modal.titleNew')}
      titlePosition="center"
      onClose={handleCloseModal}
    >
      <TodoForm todo={todo} leadId={todoLeadId} eventId={todoEventId} />
    </Modal>
  );
}
